<template>
  <div class="bg">
    <!-- <img src="../../images/bg.jpg" class="bg-pic" alt="" /> -->
    <div class="title">智慧社区后台管理系统</div>
    <el-form
      ref="loginForm"
      :model="form"
      :rules="rules"
      label-width="80px"
      class="login-box"
    >
      <h3 class="login-title">欢迎登录</h3>
      <el-form-item label="账号" prop="username">
        <el-input
          type="text"
          placeholder="请输入账号"
          v-model="form.username"
        />
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          placeholder="请输入密码"
          show-password
          v-model="form.password"
        />
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-input type="num" placeholder="请输入验证码" v-model="form.code">
          <el-button
            slot="append"
            style="width: 120px"
            :disabled="!canGetCode"
            @click="sendMessage"
          >
            {{ canGetCode ? "获取验证码" : codeCD + "秒" }}
          </el-button>
        </el-input>
      </el-form-item>

      <el-button type="primary" v-on:click="onSubmit('loginForm')">
        登录
      </el-button>
    </el-form>

    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span>请输入账号和密码</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
    <a
      href="https://beian.miit.gov.cn/#/Integrated/index"
      target="_blank"
      style="color: #909399;font-size: 12px;"
      >蜀ICP备2022000449号-1</a
    >
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      form: {
        username: "",
        password: "",
        code: "",
      },

      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        username: [
          {
            required: true,
            message: "账号不可为空",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "密码不可为空",
            trigger: "blur",
          },
        ],
      },

      // 对话框显示和隐藏
      dialogVisible: false,

      // 验证码状态
      canGetCode: true,
      codeCD: 60,
    }
  },
  methods: {
    /*发送短信验证码*/
    sendMessage() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.canGetCode = false
          this.codeInterval()
        }
      })

      this.request({
        method: "post",
        url: this.Api.SendSms,
        params: {
          username: this.form.username,
        },
      })
        .then((res) => {
          if (res.data.status !== "OK") {
            this.$message.warning(res.data.message)
            return
          }
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },

    /*提交表单*/
    onSubmit(formName) {
      // 为表单绑定验证功能
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 使用 vue-router 路由到指定页面，该方式称之为编程式导航
          this.request({
            method: "post",
            url: "/manager/auth/login",
            data: {
              username: this.form.username,
              password: this.form.password,
              code: this.form.code,
            },
          })
            .then((res) => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message(res.data.message)
                return
              }
              localStorage.setItem("token", res.data.data.token)
              localStorage.setItem("username", res.data.data.username)
              localStorage.setItem("areaType", res.data.data.areaType)
              res.data.status === "OK"
                ? this.$router.push({ name: "index" })
                : this.$alert(res.data.message)
              window.document.title = "秀水智慧社区管理系统"
            })
            .catch((err) => {
              this.$message.error(err.message)
            })
        } else {
          this.dialogVisible = true
          return false
        }
      })
    },

    /*验证码计时
     * */
    codeInterval() {
      let timer = setInterval(() => {
        this.codeCD--
        if (this.codeCD === 0) {
          clearInterval(timer)
          this.canGetCode = true
          this.codeCD = 60
        }
      }, 1000)
    },
  },
  mounted() {
    window.document.title = "秀水镇人大智慧平台"
  },
}
</script>

<style scoped lang="scss">
.login-box {
  background: {
    color: rgba(255, 255, 255, 0.8);
  }
  border: 1px solid #dcdfe6;
  width: 350px;
  margin: 180px auto;
  padding: 35px 35px 15px 35px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  box-shadow: 0 0 25px #909399;
}

.login-title {
  text-align: center;
  margin: 0 auto 40px auto;
  color: #303133;
}

.title {
  padding-top: 100px;
  font-size: 48px;
}
.bg {
  width: 100%;
  height: 100%;
  // text-align: center;
  background: url("../../images/bg.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
}
.bg-pic {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
a {
  text-decoration: none;
}
</style>
